(() => {
  const dialog = document.querySelector('dialog.bht-popup');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const key = 'embod-biohack-together-viewed-v1';
  let timer, opener;
  const remember = () => { try { sessionStorage.setItem(key, '1'); } catch {} };
  const open = trigger => {
    clearTimeout(timer);
    if (dialog.open) return;
    opener = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('bht-popup-open');
    dialog.querySelector('.bht-popup-close').focus();
    remember();
  };
  const clearHash = () => {
    if (location.hash === '#biohack-together') history.replaceState(null, '', location.pathname + location.search);
  };
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('bht-popup-open');
    clearHash();
    if (opener?.isConnected) opener.focus({preventScroll:true});
  });
  dialog.querySelector('.bht-popup-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const r = dialog.getBoundingClientRect();
    if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  });
  dialog.querySelector('.bht-popup-book').addEventListener('click', () => dialog.close());
  document.addEventListener('click', event => {
    const a = event.target.closest('a[href]');
    if (!a) return;
    const u = new URL(a.href, location.href);
    if(u.origin === location.origin && u.pathname === location.pathname && u.hash === '#biohack-together') {
      event.preventDefault(); open(a);
    }
  }, true);
  window.addEventListener('hashchange', () => { if(location.hash === '#biohack-together') open(); });
  if (location.hash === '#biohack-together') open();
  else if (!location.hash) {
    let seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; } catch {}
    if(!seen) timer = setTimeout(() => {
      if(document.visibilityState === 'visible' && !document.querySelector('dialog[open]') && !document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) open();
    }, 5000);
  }
})();
